export enum ConfigManagerProperties {
  REGION = 'region',
}
